const changeStep = (payload) => {
    return {
        type: 'SET_STEP',
        payload
    }
}

const setMaxStep = (payload) => {
    return {
        type: 'SET_MAX_STEP',
        payload
    }
}

const updateFormData = (payload) => {
    return {
        type: 'UPDATE_FORMDATA',
        payload
    }
}

const updateUserData = (payload) => {
    return {
        type: 'UPDATE_USERDATA',
        payload
    }
}

const reinitFormData = (payload = {}) => {
    return {
        type: 'REINIT_FORMDATA',
        payload
    }
}

export default { changeStep,setMaxStep, updateFormData, reinitFormData, updateUserData };